import { combineReducers } from 'redux';
import currentRestaurant from './currentRestaurant';
import restaurantSchedule from './restaurantSchedule';
import restaurantOrder from './restaurantOrder';
import loginReducer from './loginReducer';
import signUpReducer from './signUpReducer';
import ordersListReducer from './ordersListReducer';
import employeesListReducer from './employeesListReducer';
import restaurantOrdersReducer from './restaurantOrdersReducer';
import loginActions from '../actionTypes/loginActions';
import employeeReducer from './employeeReducer';
import companyHomeReducer from './companyHomeReducer';
import bulkUploadReducer from './bulkUploadReducer';
import companyReportsReducer from './companyReportsReducer';
import employeeHomeReducer from './employeeHomeReducer';
import downloadReportReducer from './downloadReportReducer';
import restaurantReportsReducer from './restaurantReportsReducer';
import mealReducer from './mealReducer';
import companiesReducer from './companiesReducer';
import companyReducer from './companyReducer';
import restaurantsReducer from './restaurantsReducer';
import restaurantReducer from './restaurantReducer';
import forgotPasswordReducer from './forgotPasswordReducer';
import resetPasswordReducer from './resetPasswordReducer';
import companyRestaurantsReducer from './companyRestaurantsReducer';
import restaurantMealsReducer from './restaurantMealsReducer';
import mealSchedulesReducer from './mealSchedulesReducer';
import restaurantMealReducer from './restaurantMeals';

const appReducer = combineReducers({
  currentRestaurant,
  restaurantSchedule,
  restaurantOrder,
  loginReducer,
  signUpReducer,
  ordersListReducer,
  employeesListReducer,
  restaurantOrdersReducer,
  employeeReducer,
  companyHomeReducer,
  bulkUploadReducer,
  companyReportsReducer,
  employeeHomeReducer,
  downloadReportReducer,
  restaurantReportsReducer,
  mealReducer,
  companiesReducer,
  companyReducer,
  restaurantsReducer,
  restaurantReducer,
  forgotPasswordReducer,
  resetPasswordReducer,
  companyRestaurantsReducer,
  restaurantMealsReducer,
  mealSchedulesReducer,
  restaurantMealReducer,
});

export default (state, action) => {
  // Clear all data in redux store to initial.
  if (action.type === loginActions.logoutUser) state = undefined;

  return appReducer(state, action);
};
